const LS_KEY = "LS_KEY"
let id = Date.now();
let tasks;
try {
    tasks = JSON.parse(localStorage.getItem(LS_KEY));
} catch (e) {
    console.error('error on parsing tasks', e);
}

export const getId = () => id++;

tasks = Array.isArray(tasks) ? tasks : [
    { checked: true, title: 'have a nice day', priority: "Normal", date: '2018-01-21' },
    { checked: false, title: 'hometask', priority: "Low", date: '2018-01-22' },
    { checked: true, title: 'kitty', priority: "Normal", date: '2018-01-23' },
    { checked: false, title: 'mom', priority: "High", date: '2018-01-24' },
    { checked: true, title: 'have a nice day', priority: "High", date: '2018-01-25' },
].map(item => ({ ...item, id: getId() }));

const saveTasks = () => localStorage.setItem(LS_KEY, JSON.stringify(tasks));

///get all the Tasks from the list on server
export const getTasks = () => new Promise(resolve =>
    setTimeout(resolve, 0, [...tasks]));

///add new Task to list on server
export const addTask = data => {
    let task = { ...data, id: getId() };
    tasks.push(task);
    saveTasks();
    return new Promise(resolve => setTimeout(resolve, 200, task));
}

//remove task from list on the server
export const removeTask = id => {
    tasks = tasks.filter(item => item.id !== id);
    saveTasks();
    return new Promise(resolve => setTimeout(resolve, 200, id));
}

//update task on the server
export const updateTask = (id, changes) => {
    tasks = tasks.map(item => item.id !== id ? item : {
        ...item,
        ...changes
    });
    saveTasks();
    return new Promise((resolve) => setTimeout(resolve, 100, {
        ...tasks.find(item => item.id === id)
    }));
}
export const loginUser = (login, password) => {
    return new Promise((resolve, reject) => {
        if (!isNaN(+login) && !isNaN(+password) && login.length + 1 === password.length) {
            setTimeout(resolve, 300, 'password accepted');
        } else {
            setTimeout(reject, 1000, 'incorect login or password');
        }
    })
}


// WEBPACK FOOTER //
// ./src/utils/apiWrapper.js